import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../Store/Hooks'
import { setLoader } from '../../Store/Slice/loader.slice'
import { showAlert } from '../../Store/Slice/alert.slice'
import {
  combineErrorMessage,
  getLayoutFilterValue,
  transformRightDrawerLayoutResponse,
} from '../../Helpers/Util'
import { parentContainerDetailSelector } from '../../Store/Slice/manage-container.slice'
import {
  CONTAINER_MANAGEMENT_CRUD,
  CONTAINER_DEFINITION_CRUD,
} from '../../Constants/ApiDefinations'
import CONSTANTS, { PAGES_ROUTES } from '../../Constants'
import RightDrawerSelector from '../../Helpers/RightDrawerSelector'
import mainApiService from '../../Services'
import { FetchRightDrawerLayout, RightDrawerSubmit } from '../../Models/CommonListHeadingModal'

const { ManageContainer, Create, View } = PAGES_ROUTES
const {
  EXCLUDE_LAYOUTS_PARENT_RIGHT_DRAWER,
  INCLUDE_LAYOUTS_CHILD_RIGHT_DRAWER,
  INCLUDE_PAGES_CHILD_RIGHT_DRAWER,
} = CONSTANTS

const ContainerRightDrawer = ({
  drawerTitle = 'Create',
  child = false,
  onCancel,
  open = false,
  defaultLayout,
}: any) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parentContainerDetail = useAppSelector(parentContainerDetailSelector)

  const fetchTypes = async () => {
    const requestedData: any = CONTAINER_MANAGEMENT_CRUD.TYPES()
    const result: any = await mainApiService(requestedData)
    if (result?.responseCode === 200) {
      let list: any[] = result?.data?.records || []
      if (child) {
        list = list.filter((item: any) =>
          INCLUDE_PAGES_CHILD_RIGHT_DRAWER.includes(item?.toLowerCase()),
        )
      }
      list = list.map((type: any) => ({
        key: type,
        value: type,
      }))
      dispatch(setLoader(false))
      return list
    } else {
      dispatch(showAlert([true, combineErrorMessage(result), 'error']))
      dispatch(setLoader(false))
      return []
    }
  }

  const fetchLayouts = async (typeKey: FetchRightDrawerLayout) => {
    const layoutFilterValue = getLayoutFilterValue(typeKey, 'container_type')
    if (layoutFilterValue.length === 0) return []

    const requestedData: any = CONTAINER_MANAGEMENT_CRUD.LAYOUTS(layoutFilterValue)
    const result: any = await mainApiService(requestedData)
    if (result?.responseCode === 200) {
      const layouts: any[] = result?.data?.records || []
      let filteredLayouts = []
      if (!child) {
        filteredLayouts = layouts.filter(
          (item) => !EXCLUDE_LAYOUTS_PARENT_RIGHT_DRAWER.includes(item?.layout?.toLowerCase()),
        )
      } else {
        filteredLayouts = layouts.filter((item) =>
          INCLUDE_LAYOUTS_CHILD_RIGHT_DRAWER.includes(item?.layout?.toLowerCase()),
        )
      }
      return transformRightDrawerLayoutResponse(filteredLayouts, 'containerTypeTitle')
    }
    return []
  }

  const handleSubmit = async ({ selectedLayout, selectedType }: RightDrawerSubmit) => {
    if (child) {
      const inheritPayload: { parentContainerId?: string; assetTypeId?: string } = {}
      inheritPayload['parentContainerId'] = parentContainerDetail?._id
      const layouts = await fetchLayouts({ moduleKey: selectedType })
      const layoutObj = layouts.find((layout) => layout.value === selectedLayout)
      const layoutName = layoutObj ? layoutObj.key : selectedLayout
      const requestedData: any = CONTAINER_DEFINITION_CRUD.INHERIT_CONTAINER({
        layout: layoutName,
        ...inheritPayload,
      })
      const result: any = await mainApiService(requestedData)
      if (result?.responseCode === 200) {
        navigate(`/${ManageContainer}/${View}/${result?.data?._id}`)
      } else if (result?.error?.boltCode === 'BOLT_16038') {
        navigate(`/${ManageContainer}/${Create}/${selectedLayout}`)
      }
    } else {
      navigate(`/${ManageContainer}/${Create}/${selectedLayout}`)
    }
  }

  return (
    <RightDrawerSelector
      open={open}
      onCancel={onCancel}
      drawerTitle={drawerTitle}
      moduleType='Container'
      fetchTypes={fetchTypes}
      fetchLayouts={fetchLayouts}
      onSubmit={handleSubmit}
      defaultLayout={defaultLayout}
    />
  )
}

export default ContainerRightDrawer
